module.exports = __webpack_public_path__ + "img/loader.54c96e01.gif";